import { render, staticRenderFns } from "./riskEvaluationModel.vue?vue&type=template&id=ab893208&scoped=true&"
import script from "./riskEvaluationModel.vue?vue&type=script&lang=js&"
export * from "./riskEvaluationModel.vue?vue&type=script&lang=js&"
import style0 from "./riskEvaluationModel.vue?vue&type=style&index=0&id=ab893208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab893208",
  null
  
)

export default component.exports